import { useCallback } from "react";

import type { ImportTarget } from "@skilitics/nautilus-core-designer-data";
import type { NodeTemplate } from "@skilitics/nautilus-endpoint-definition";

import type { ImportNodeOptions } from "../../../slots/types.ts";
import { useImportNodeDesign } from "../../../slots/useImportNodeDesign.tsx";
import { useMutateNodeDesigns } from "../../../state/index.ts";

export const useImportTemplate = (importOptions: ImportNodeOptions) => {
  const importNodeDesign = useImportNodeDesign(importOptions);
  const { addMultilingual, replace } = useMutateNodeDesigns();

  return useCallback(
    async (template: NodeTemplate, target: ImportTarget) => {
      const { id, content } = template;

      const addableNode = await importNodeDesign(content, target);
      addableNode.upstreamTemplateId = id;

      if ("slotId" in target) {
        addMultilingual(addableNode, target.slotId);
      } else {
        replace(target.slotResidentNodeId, addableNode);
      }

      return addableNode;
    },
    [addMultilingual, importNodeDesign, replace],
  );
};
